var helpers = require('Helpers')
    $       = global.jQuery
    emitter = require('events');
 
    var _emitter = new emitter()
    var ApplicationEvents = {
       
        emitter: _emitter
       ,makeTrigger: function (event, arg1, arg2) { return function () { _emitter.emit(event, arg1, arg2) } }

       ,new_user_session              : 'new_user_session'
       ,selected_call_id              : 'selected_call_id'
       ,reset_call                    : 'reset_call'
       ,clear_answers                 : 'clear_answers'
       ,call_info                     : 'call_info'
       ,enter_call                    : 'enter_call'
       ,leave_call                    : 'leave_call'
       ,form_selected                 : 'form_selected'
       ,form_model                    : 'form_model'
       ,exit_grid                     : 'exit_grid'
       ,grid_layout                   : 'grid_layout'
       ,layout_change                 : 'layout_change'
       ,info                          : 'info'
       ,error                         : 'error'
       ,success                       : 'success'
       ,warning                       : 'warning'
       ,busy_message                  : 'busy_message'
       ,questionnaire_onboard         : 'questionnaire_onboard'
       ,answer_update                 : 'answer_update'
       ,answer_update_complete        : 'answer_update_complete'
       ,update_complete               : 'update_complete'
       ,resize                        : 'resize'
       ,request_download              : 'request_download'
       ,file_info                     : 'file_info'
       ,confirm_save                  : 'confirm_save'
       ,call_upload_complete          : 'call_upload_complete'
       ,gallery_home_selected         : 'gallery_home_selected'
       ,gallery_filters_requested     : 'gallery_filters_requested'
       ,gallery_primary_filters_requested : 'gallery_primary_filters_requested'
       ,gallery_view_option_change    : 'gallery_view_option_change'
       ,find_pictures                 : 'find_pictures'
       ,pagination_page_change        : 'pagination_page_change'
       ,get_gallery_data_page         : 'get_gallery_data_page'
       ,gallery_details_requested     : 'gallery_details_requested'
       ,set_picture_selection_state   : 'set_picture_selection_state'
       ,selection_count               : 'selection_count'
       ,request_bulk_picture_download : 'request_bulk_picture_download'
       ,request_bulk_picture_update   : 'request_bulk_picture_update'
       ,gallery_save_key              : 'gallery_save_key'
       ,gallery_splash_selected       : 'gallery_splash_selected'
       ,file_downloaded               : 'file_downloaded'
       ,status_changed                : 'status_changed'
       ,manager_code_set              : 'manager_code_set'
       ,view_mode_change              : 'view_mode_change'
       ,repository_changes            : 'repository_changes'
       ,remove_history_item           : 'remove_history_item'
       ,picture_filters_view_initialized :'picture_filters_view_initialized'
    }


module.exports = ApplicationEvents;